export const decHex = (sensorId) => {
  const hex = parseInt(sensorId).toString(16);

  return hex.length === 6 ? hex.toUpperCase() : sensorId;
};

export const calcSensorHex = (hardwareId, sensorId) =>
  sensorId ? decHex(sensorId) : hardwareId ? decHex(hardwareId) : '---';


export const daysBetween = (from, to) => to.diff(from, 'days');

export const toCurrency = (value) =>
  parseFloat(value || 0).toLocaleString('en-EN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const toCurrencyCeil = (value) => Math.ceil(parseFloat(value || 0)).toLocaleString('en-EN');

export const fullName = (nameFirst, nameLast) => {
  return (
    nameFirst.charAt(0).toUpperCase() +
    nameFirst.slice(1).toLowerCase() +
    ' ' +
    nameLast.charAt(0).toUpperCase() +
    nameLast.slice(1).toLowerCase()
  );
};
